<style scoped lang="sass">
.math-rows
  display: flex
  flex-direction: column
  .math-row
    display: flex
    flex-direction: row
    &.math-total
      border-top: 1px solid var(--light-gray)
      margin-top: 0.5rem
      padding-top: 0.5rem
      font-weight: 600
    >:first-child
      flex-basis: 2rem
      font-weight: 600
    >:last-child
      flex-grow: 1
</style>
<template>
  <pinhigh-modal :on-close="onClose">
    <div class="math-rows" v-if="math.length">
      <div v-for="line in math" class="math-row">
        <div>{{line.value}}</div>
        <div>{{line.text}}</div>
      </div>
      <div class="math-row math-total">
        <div>{{totalValue}}</div>
        <div>Total Points</div>
      </div>
    </div>
    <div v-else>
      No details available
    </div>
  </pinhigh-modal>
</template>
<script>
export default {
  name: 'MathModal',
  props: {
    participation: Object,
    onClose:       Function
  },
  computed: {
    math() {
      return this.participation.math ? this.participation.math : [];
    },
    totalValue() {
      return this.math.reduce((memo,{value}) => memo + value, 0);
    }
  }
};
</script>
